export default __webpack_public_path__ + "static/media/trackerIcon.7a8affb8.webp";